/* eslint-disable */
import Component from '../../js/_Component';
import LoadMapsAPI from '../../js/util/_GoogleMaps';
let InfoBox = null;

interface CustomMarker extends google.maps.Marker {
	country: string;
}

export class PageDealers extends Component {

	public thisGoogleMap: google.maps.Map = null; // Was FVD.page.pages["dealers"].map["map"]
	public mapMarkers: CustomMarker[] = []; // List of every map marker FVD.page.pages["dealers"].map["markers"]
	public testCircle: google.maps.Circle = null; // FVD.page.pages["dealers"].map["testCircle"];
	public searchMarker: google.maps.Marker = null; // FVD.page.pages["dealers"].map["searchMarker"]
	public infoBoxArray = []; // Was "info" in the main createMap()

	constructor(element: HTMLElement) {
		super(element);

		// AIzaSyDMOUxsPLs2KYh7mNn1AmP6KOp9vZlbtQ4 FVD
		// AIzaSyBt3jVcXyxpSIrL_RRF7O9YTrhDIjJCeeE TB
		// This may not work if they haven't opened up for new domain

		const gmapKey = "AIzaSyBt3jVcXyxpSIrL_RRF7O9YTrhDIjJCeeE";
		const mapURL = "https://maps.googleapis.com/maps/api/js?key="+ gmapKey +"&libraries=geometry";
		LoadMapsAPI(mapURL)
			.then(()=>{
				InfoBox = (window as any).InfoBox;
				this.createMap();
				this.createBinds();
			});
	}


	createBinds() {
	// Search by Press
		let searchInput = document.querySelector('.c-page-dealers .sidebar input') as HTMLInputElement;
		searchInput.onkeyup = (keypress)=>{
			if(keypress.which == 13) {
				this.searchDealers(searchInput);
			}
		};

		let searchButton = document.querySelector('.c-page-dealers .sidebar .icon-icon-search') as HTMLElement;
		searchButton.onclick = ()=>{
			this.searchDealers(searchInput);
		};

		let internationalButton = document.querySelector('.c-page-dealers .international-button') as HTMLElement;
		internationalButton.onclick = ()=>{
			// Before this used to toggle a plus sign on the button

			let internationalButtonIcon = internationalButton.querySelector('.toggle span');

			if(internationalButtonIcon.classList.contains('icon-icon-plus')){
				internationalButtonIcon.classList.remove('icon-icon-plus');
				internationalButtonIcon.classList.add('icon-icon-minus');

				this.buildInternationalList();
			} else {
				internationalButtonIcon.classList.add('icon-icon-plus');
				internationalButtonIcon.classList.remove('icon-icon-minus');

				document.querySelector('.sidebar .results').innerHTML = ""; // Remove HTML
			}

		}

	}

	searchDealers(thisEl: HTMLInputElement){
		var searchRequest = thisEl.value;
		searchRequest = searchRequest.replace(/ /g,'');

		// Check to see if this is a valid zipcode
		if( (searchRequest.length > 7) || (searchRequest.length < 5) ){
			this.errorHandler("Not a valid zipcode.",false);
		} else {
			this.zipCodeSearch(searchRequest);
		}
	}



	/**
	 * Submits the form data.
	 * @param {string} Zipcode
	 */
	zipCodeSearch(searchRequest) {
		// Build endpoint
		//var endpoint = "https://ziplookup.tige.com/query.php?zip=" + searchRequest; // Old method. Would return data not encoded like: [{"lat":"30.402665","lng":"-97.761062"}]
		var endpoint = "/api/geolocate.php?address=" + searchRequest; // New method that uses Google. Returns data encoded like: {"lat":30.401356,"lng":-97.752535199999997}

		// Start Fetch
		fetch(endpoint, {
			method: 'GET',
			headers: {'Content-Type': 'application/json'}
		})
			.then((response) => response.json())
			.then((response) => this.onSuccess(response))
			.catch(() => this.onFailure());
	}

	onSuccess(response) {
		var validResponse = false;
		if(response.length > 0){

			if (response[0].lat.length > 0){
				validResponse = true;

				// Reset position
				this.resetPosition(response[0]);
			}
		}

		// Error
		if (validResponse){
			this.errorHandler("All good.",true);
		} else {
			this.errorHandler("Not a valid zipcode.",false);
		}

	}

	onFailure() {
		console.warn("Failure from zipcode search");
	}

	/**
	 * error
	 * Handles showing or hiding errors
	 * @param el Element of page
	 * @param msg Message to be passed into error block
	 * @param clear Clear the error block, true/false
	 */
	errorHandler(msg,clear) {
		if(!clear){
			document.querySelector('.c-page-dealers .error-wrapper').classList.remove('hide');
			document.querySelector('.c-page-dealers .error-wrapper p').innerHTML = msg;
		} else {
			document.querySelector('.c-page-dealers .error-wrapper').classList.add('hide')
		}

	}

	/**
	 * Returns a bounds object for a given list of markers
	 * @param {array} markers he markers
	 * @return {LatLngBounds} The bounds object
	 */
	getBoundsForMarkers(markers) {
		let marker;
		const bounds = new google.maps.LatLngBounds();

		for (let _i = 0, _len = markers.length; _i < _len; _i++) {
			marker = markers[_i];
			bounds.extend(marker.getPosition());
		}
		return bounds;
	}

	/**
	 * @param obj lat/lng object
	 */
	resetPosition(obj) {

		// Define new map position
		var map_position = new google.maps.LatLng(obj.lat,obj.lng);

		// Remove any existing search markers
		if (this.searchMarker) {
			this.searchMarker.setMap(null);
		}

		// Set marker where search results returned
		var pushObj = {
			position: map_position,
			icon: {
				url: "/assets/ui/map-marker-search-location.png",
				scaledSize: new google.maps.Size(40,40)
			},
			map: this.thisGoogleMap,
			info: "-",
			title: "search-marker",
			country: "-"
		};

		// Store reference of the search marker
		this.searchMarker = new google.maps.Marker(pushObj);

		// Move the map to search location
		this.thisGoogleMap.setCenter(map_position);

		// Write out closest 3 dealers to zip
		this.mapByDistance(obj);
	}

	/**
	 * @param obj lat/lng object
	 */
	mapByDistance(obj) {

		var latLng = new google.maps.LatLng(obj.lat,obj.lng);

		this.testCircle = new google.maps.Circle({
			strokeOpacity: 0,
			fillOpacity: 0,
			map: this.thisGoogleMap,
			center: latLng,
		});

		var distanceArray = [];

		// For each marker gather distance from point store in array
		for(var i=0;i<this.mapMarkers.length;i++){
			distanceArray[i] = {
				"distance":this.checkDistance(latLng,this.mapMarkers[i].getPosition()),
				"title":this.mapMarkers[i].getTitle(),
				"marker":this.mapMarkers[i]
			};
		}

		// Sort by distance
		distanceArray.sort(function(a,b){
			var i = a.distance;
			var j = b.distance;
			if(i > j){
				return 1;
			}
			if(j > i){
				return -1;
			}
			return 0;
		});

		// Get top 3 results
		var topLocations = distanceArray.slice(0,3);
		var output = '<div>';

		// Loop through and output results
		for(var i=0;i<topLocations.length;i++){

			// Distance
			var km =  Math.round(topLocations[i].distance/100)/10
			var miles = Math.round((topLocations[i].distance*0.000621371192)*10)/10;

			// Info
			var markerLocation = document.createElement('div');
			markerLocation.innerHTML = topLocations[i].marker.info;

			markerLocation.querySelector('.infoboxheader').remove();
			markerLocation.querySelector('br').remove();

			// Build HTMl for output
			output = output + '<div class="location-container">';
			output = output + '<div class="h-type h-type--theme-dark-type"><h4>' + topLocations[i].title + '</h4></div>';
			output = output + '<div class="distance">' + '<span class="miles">' + miles + ' miles</span> <span class="km">(' + km + ' km)</span>' + '</div>';
			output = output + markerLocation.innerHTML;
			output = output + '</div>';
		}

		output = output + "</div>";

		// Clear out existing results
		let resultsContainer = this.element.querySelector('.sidebar .results') as HTMLElement;
		resultsContainer.innerHTML = output; // Takes compiled HTML and places it in the results

		// Re-Center Canvas
		// Get Just Markers
		var topMarkers = []
		for(var i = 0;i<topLocations.length;i++){
			topMarkers[i] = topLocations[i].marker;
		}
		topMarkers[topMarkers.length] = this.searchMarker;

		var bounds = this.getBoundsForMarkers(topMarkers);
		this.thisGoogleMap.fitBounds(bounds);
	}


	/**
	 * Builds list of all map pins outside of US and Canada
	 */
	buildInternationalList() {
		var intArray = [];
		var intCount = 0;
		var output = '<div>';

		// Get a full list of non US/CAN
		for(var i=0;i<this.mapMarkers.length;i++){
			// Test to see if each marker is within us/can.
			if((this.mapMarkers[i].country != "United States") && (this.mapMarkers[i].country != "Canada")) {
				intArray[intCount] = {
					"title":this.mapMarkers[i].getTitle(),
					"country":this.mapMarkers[i].country,
					"marker":this.mapMarkers[i]
				};
				intCount++;
			}
		}

		// Sort by Country
		intArray.sort(function(a,b){
			var i = a.country;
			var j = b.country;
			if(i > j){
				return 1;
			}
			if(j > i){
				return -1;
			}
			return 0;
		});

		// Loop through and output results
		for(var i=0;i<intArray.length;i++){
			// Info
			var markerLocation = document.createElement('div');
			markerLocation.innerHTML = intArray[i].marker.info;
			markerLocation.querySelector('.infoboxheader').remove();
			markerLocation.querySelector('br').remove();

			// Build HTMl for output
			output = output + '<div class="location-container">';
			output = output + '<div class="h-type h-type--theme-dark-type"><h4>' + intArray[i].title + '</h4></div>';
			output = output + markerLocation.innerHTML;
			output = output + '<br>' + intArray[i].country;
			output = output + '</div>';
		}

		output = output + "</div>";

		// Clear out existing results
		let resultsContainer = this.element.querySelector('.sidebar .results') as HTMLElement;
		resultsContainer.innerHTML = output; // Takes compiled HTML and places it in the results

		// Re-Center Canvas
			// Get Just Markers
			var topMarkers = []
			for(var i = 0;i<this.mapMarkers.length;i++){
				topMarkers[i] = this.mapMarkers[i];
			}

		var bounds = this.getBoundsForMarkers(topMarkers);
		this.thisGoogleMap.fitBounds(bounds);
	}

	/**
	 * @param position lat/lng object
	 */
	checkDistance(latLngA,latLngB) {
		if(google.maps.geometry.spherical.computeDistanceBetween) {
			return google.maps.geometry.spherical.computeDistanceBetween(latLngA, latLngB);
		} else {
			console.warn("No resource found at google.maps.geometry.spherical.computeDistanceBetween");
		}
	};

	/**
	 * Gathers all dealer info and prepares it for the Google Map.
	 */
	gatherDealers() {
		// Gather
		const allLocations = this.element.querySelectorAll('.c-page-dealers__map-data-holder .c-page-dealers__map-data') as NodeListOf<HTMLElement>;
		allLocations.forEach((thisLocation: HTMLElement)=>{

			const pushObj = {
				position: new google.maps.LatLng( Number(thisLocation.dataset.lat) , Number(thisLocation.dataset.lon)),
				map: this.thisGoogleMap,
				icon: {
					url: thisLocation.dataset.marker,
					scaledSize: new google.maps.Size(
						Number(thisLocation.dataset.markerWidth),
						Number(thisLocation.dataset.markerHeight),
					),
				},
				info: thisLocation.innerHTML,
				title: thisLocation.dataset.title,
				country: thisLocation.dataset.country
			};

			// Push the data to the map array
			this.mapMarkers.push(new google.maps.Marker(pushObj) as CustomMarker);

			// Add a listener (For sidebar info)
			// TODO work back in
			// google.maps.event.addListener(pushObj, 'click', onMarkerClickSidebar);

			// Infobox styling

			this.infoBoxArray.push(
				new InfoBox({
					content: thisLocation.innerHTML,
					alignBottom: true,
					pixelOffset: new google.maps.Size(-254,-50),
					closeBoxURL: '/assets/ui/map-pin-close.png'
					//disableAutoPan: true
				})
			);
		});
	}

	// Infobox.js Replacement style.
	openMarker(index) {

		google.maps.event.addListener(this.mapMarkers[index], 'click', (_e) => {

			// Open if currently not visible.
			let open = !this.infoBoxArray[index].getVisible();

			// Close all boxes.
			for (var j in this.infoBoxArray) {
				if (this.infoBoxArray[j].getVisible()) {
					this.infoBoxArray[j].close(this.thisGoogleMap, this.mapMarkers[j]);
				}
			}

			if (open) {
				this.infoBoxArray[index].open(this.thisGoogleMap, this.mapMarkers[index]);
			}
		});
	}

	createMap() {
		// Area Google Map will be placed
		const mapElement = this.element.querySelector('.google-map');

		// Setup Map Options
		var tigeLat = 32.427593;
		var tigeLng = -99.680064;

		var mapOptions: google.maps.MapOptions = {
				zoom: 9,
				center: new google.maps.LatLng(tigeLat,tigeLng),
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				styles: [{"featureType":"all","elementType":"labels.text.fill","stylers": [{"saturation": 36},{"color":"#333333"},{"lightness": 40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers": [{"visibility":"on"},{"color":"#ffffff"},{"lightness": 16}]},{"featureType":"all","elementType":"labels.icon","stylers": [{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers": [{"color":"#fefefe"},{"lightness": 20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers": [{"color":"#58585a"},{"lightness": 17},{"weight": 1.2}]},{"featureType":"administrative.country","elementType":"geometry.fill","stylers": [{"lightness":10}]},{"featureType":"landscape","elementType":"geometry","stylers": [{"color":"#f5f5f5"},{"lightness": 20}]},{"featureType":"landscape","elementType":"geometry.fill","stylers": [{"color":"#f2f2f2"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry.fill","stylers": [{"gamma":4.86}]},{"featureType":"poi","elementType":"geometry","stylers": [{"color":"#f5f5f5"},{"lightness": 21}]},{"featureType":"poi.park","elementType":"geometry","stylers": [{"color":"#dedede"},{"lightness": 21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers": [{"color":"#ffffff"},{"lightness":-17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers": [{"color":"#ffffff"},{"lightness":-66},{"weight":0.02}]},{"featureType":"road.arterial","elementType":"geometry","stylers": [{"color":"#ffffff"},{"lightness": 18}]},{"featureType":"road.local","elementType":"geometry","stylers": [{"color":"#ffffff"},{"lightness": 16}]},{"featureType":"transit","elementType":"geometry","stylers": [{"color":"#f2f2f2"},{"lightness": 19}]},{"featureType":"water","elementType":"geometry","stylers": [{"color":"#e9e9e9"},{"lightness": 17}]}]
			};
		var mapCanvas = mapElement; // HTML Element map is tossed into
		this.thisGoogleMap = new google.maps.Map(mapCanvas, mapOptions ); // Instance created to this var
		var mapBounds = new google.maps.LatLngBounds();



		// Pull in point data via the .map-data elements
		this.gatherDealers();

		// For infobox styling

		//Auto Centering
		for(var i in this.mapMarkers){
			this.openMarker(i); // TODO work back in with infobox
			mapBounds.extend(this.mapMarkers[i].getPosition());
		}


		// Zoom to specific distance
		const zoom = 7;
		this.thisGoogleMap.setZoom(zoom > 15 ? 15 : zoom);

		// Redraw the map upon expansion
		// Note this is only because Google Map hates being loaded into a hidden div, redrawing on open
		/* TODO work back in, possibly not even used?
		$(el).find('.expansion-block').on("click",".title-block, .expand-block",function(){
			setTimeout(function(){
				google.maps.event.trigger(this.thisGoogleMap, 'resize');
				this.thisGoogleMap.fitBounds(mapBounds);
				zoom = this.thisGoogleMap.getZoom();
				this.thisGoogleMap.setZoom(zoom > 15 ? 15 : zoom);
			},500);
		});
		*/
	}

}

Component.register(PageDealers, "PageDealers");
